export default {
    eur: "EUR",
    eur_name: "EUR",
    gbp: "GBP",
    gbp_name: "British Pound",
    sek: "SEK",
    sek_name: "Swedish Krona",
    hcf: "HCF",
    hcf_name: "Swiss Franc",
    cny: "CNY",
    cny_name: "CNY",
    usd: "USD",
    usd_name: "Dollar",
    rub: "RUB",
    rub_name: "Russischer Rubel",
    ils:"ILS",
    ils_name:"Israelische Schekel",
    
    common_00001:"Logout",
    common_00002:"YYYY/MM/DD",
    common_00003:"YYYY/MM/DD HH:mm:ss",
    common_00004:"Stations",
    common_00005:"Vorgänge",
    common_00006:"Maintenance",
    common_00007:"Security",
    common_00008:"User",
    common_00009:"Marketing",
    common_00010:"Data",
    common_00011:"Finance",
    common_00012:"Diversion",
    common_00013:"System",
    common_00014:"Übersicht der Überwachung",
    common_00015:"Startseite",
    common_00016:"Gesamtübersicht",
    common_00017:"Echtzeit-Überwachung",
    common_00018:"年度统计",
    common_00019:"维修指标",
    common_00020:"Abnormale Vorgänge",
    common_00021:"Ladestationen Management",
    common_00022:"Ladestation erstellen",
    common_00023:"Tarif management",
    common_00024:"Tarif Vorlage",
    common_00025:"充电费付费方式管理",
    common_00026:"预付费",
    common_00027:"后付费",
    common_00028:"Geräte management",
    common_00029:"占用费收取方式管理",
    common_00030:"云控车位锁",
    common_00031:"桩控车位锁",
    common_00032:"广告投放",
    common_00033:"设备广告投放",
    common_00034:"公众号广告投放",
    common_00035:"客户端场站展示标签",
    common_00036:"系统级营销类标签",
    common_00037:"场站级经营类标签",
    common_00038:"耗能管理",
    common_00039:"耗能统计",
    common_00040:"场站耗能管理",
    common_00041:"Regierungsplatform andocken",
    common_00042:"Franchise Management",
    common_00043:"Franchise einladen",
    common_00044:"Ladevorgänge",
    common_00045:"Einzelne Ladevorgänge",
    common_00046:"Gruppeladevorgänge",
    common_00047:"Ladevorgang von Dritten ",
    common_00048:"abnormaler Vorgang",
    common_00049:"Alle Ladevorgänge",
    common_00050:"Gutscheinbestellung",
    common_00051:"Belegungsrechnung",
    common_00052:"Operationsüberwachung",
    common_00053:"Echtzeit-Überwachung",
    common_00054:"Abnormale Vorgänge",
    common_00055:"维护指标",
    common_00056:"Log suchen",
    common_00057: "device exception log",
    common_00058: "vehicle charging log",
    common_00059: "platform business log",
    common_00060:"Fehlerbehebung",
    common_00061:"Aktuelle Fehler",
    common_00062:"Leistungsmodulswartung",
    common_00063:"充电安全策略",
    common_00064:"站点车辆充电限制",
    common_00065:"高危车型管理",
    common_00066:"主动实时防护",
    common_00067:"Schwarze",
    common_00068:"Benutzer",
    common_00069:"Benutzerverwaltung",
    common_00070:"Nutzerklassifikation",
    common_00071:"Klassifikationsmanagement",
    common_00072:"Gruppe",
    common_00073:"Gruppenzahlung",
    common_00074:"Individuelle Zahlung",
    common_00075:"Verwaltung aller Gruppen",
    common_00076:"Karten aufladen",
    common_00077:"Verwaltung der Karte",
    common_00078:"PnC-Karte",
    common_00079:"Online Ausweiskarte ",
    common_00080:"Offline Start-Stopp-Karte",
    common_00081:"Offline-Speicherwertkarte",
    common_00082:"EV Fzg",
    common_00083:"Fahrzeug",
    common_00084:"Wechat",
    common_00085:"Kundendienst",
    common_00086:"Mitglied",
    common_00087:"Mitgliedermanagement",
    common_00088:"Gutschein Instrument",
    common_00089:"Vouchar",
    common_00090:"Coupon",
    common_00091:"Coupon",
    common_00092:"Elektrizitätpaket",
    common_00093:"Servicegebührcoupon",
    common_00094:"Activity",
    common_00095:"Stored value return",
    common_00096:"Free collection",
    common_00097:"注册送返活动",
    common_00098:"充电送返活动",
    common_00099:"累计送返活动",
    common_00100:"累计充电活动",
    common_00101:"Servicegebührcoupon",
    common_00102:"Freunde einladen",
    common_00103:"Gutscheinverkauf",
    common_00104:"Gutschein in Regal",
    common_00105:"Gutscheinbestellung",
    common_00106:"Verkaufsartikel-Verbrauchsstatistik",
    common_00107:"Gutscheinverteilung",
    common_00108:"Gutscheinverteilung",
    common_00109:"Kanaleinlösenrekord",
    common_00110:"已兑换优惠消耗统计",
    common_00111:"Effizienzanalyse",
    common_00112:"Gesamtebene",
    common_00113:"Standortebene",
    common_00114:"Gerätsebene",
    common_00115:"Hauptverkehrszeiten",
    common_00116:"DurchschnittsLeistung",
    common_00117:"Franchisenehmer-Ebene",
    common_00118:"Analyse des Ladungsvolumens",
    common_00119:"Gesamtebene",
    common_00120:"Standortebene",
    common_00121:"Gruppenebene",
    common_00122:"Benutzerquellen",
    common_00123:"Franchisenehmer-Ebene",
    common_00124:"Analyse der Einkommen",
    common_00125:"Gesamtebene",
    common_00126:"Standortebene",
    common_00127:"Gruppenebene",
    common_00128:"毛利率分析",
    common_00129:"Benutzerquellen",
    common_00130:"Franchisenehmer-Ebene",
    common_00131:"充电订单金额分析",
    common_00132:"Analyse der Nutzer",
    common_00133:"Gesamtebene",
    common_00134:"Standortebene",
    common_00135:"Benutzerquellen",
    common_00136:"Nutzerbeiträge",
    common_00137:"RFM-Modellanalyse",
    common_00138:"Franchisenehmer-Ebene",
    common_00139:"卡券分析",
    common_00140:"销售趋势分析",
    common_00141:"销售分布分析",
    common_00142:"充值分析",
    common_00143:"充值金额分析",
    common_00144:"充值用户数分析",
    common_00145:"退款分析",
    common_00146:"退款金额分析",
    common_00147:"退款用户数分析",
    common_00148:"钱包分析",
    common_00149:"钱包余额趋势分析",
    common_00150:"钱包余额消耗方式分析",
    common_00151:"Häufig verwendete Funktionen",
    common_00152:"Individuelle Rechnung",
    common_00153:"Gruppenrechnung",
    common_00154:"Erstattungen",
    common_00155:"Vorgänge suchen",
    common_00156:"Finanzstatistiken",
    common_00157:"Aufladebetrag",
    common_00158:"Erstattungsbetrag",
    common_00159:"Saldo der Brieftasche",
    common_00160:"Betrag der Karte",
    common_00161:"Finanzeinstellung",
    common_00162:"Benutzererstattung",
    common_00163:"Erstattung",
    common_00164:"Benutzerfakturierung",
    common_00165:"Reserven durch Dritten",
    common_00166:"Rechnungsstellung",
    common_00167:"Aufladung",
    common_00168:"Selbstbedingungs-bezahlen",
    common_00169:"Plattformrechnung",
    common_00170:"Konto mangement",
    common_00171:"申请发票",
    common_00172:"发票明细",
    common_00173:"平台代开发票",
    common_00174:"Offene Leads",
    common_00175:"Map Plattform",
    common_00176:"Fahrzeugberieb",
    common_00177:"Aggregationsplattformen",
    common_00178:"Plattformen der Regierung",
    common_00179:"流量分析",
    common_00180:"Drittenfluss",
    common_00181:"Betriebsprotokoll",
    common_00182:"Konto mangement",
    common_00183:"Betriebsprotokoll",
    common_00184:"andere Einstellung",
    common_00185:"API",
    common_00186:"CPO",
    common_00187:"Informationseinstellung",
    common_00188:"Konto und Zugang",
    common_00189:"客户端设置",
    common_00190:"Wechat",
    common_00191:"Alipay",
    common_00192:"Begrüßungsnachricht",
    common_00193: "Fahrzeug zufügen",
    common_00194: "Fahrzeug bearbeiten",
    common_00195: "Kennzeichen",
    common_00196: "Fahrzeug-VIN-Code",
    common_00197: "Tel-Nr.",
    common_00198: "Modell | (optional)",
    common_00199: "Standort | (optional)",
    common_00200: "Bundesland/Stadt",
    common_00201: "erfolgreiche Änderung",
    common_00202: "Informationen",
    common_00203: "Ladegerät",
    common_00204: "Startzeit",
    common_00205: "Endzeit",
    common_00206: "Strompreis",
    common_00207: "Servicegebühr",
    common_00208: "Verzugsgebühr",
    common_00209: "kWh",
    common_00210: "Minute",
    common_00211: "App-Nutzer",
    common_00212: "Zufügen",
    common_00213: "ändern",
    common_00214: "Löschen",
    common_00215: "Abbrechen",
    common_00216: "erfolgreiche Löschen",
    common_00217: "Speichern",
    common_00218: "Standort",
    common_00219: "Ladepunkt",
    common_00220: "Betriebsprotokoll",
    common_00221: "Laden gestartet",
    common_00222: "Laden beendet",
    common_00223: "Ladezeit",
    common_00224: "Volumen",
    common_00225: "Rabatt",
    common_00226: "Start/Stopp-Karte",
    common_00227: "Prepaidkarte",
    common_00228: "Online-ID-Karte",
    common_00229: "Einzelheit",
    common_00230: "Gruppenutzer",
    common_00231: "Drittanbieter",
    common_00232: "Gutscheinbestellung",
    common_00233: "Benachrichtigen",
    common_00234: "Bestätigen",
    common_00235: "Alle Standorte",
    common_00236: "Selbst betriebene Website",
    common_00237: "Franchisee",
    common_00238: "Standortname eingeben",
    common_00239: "Suchen",
    common_00240: "leeren",
    common_00241: "Erfolgreich hinzugefügt",
    common_00242: "h",
    common_00243: "Administrator",
    common_00244: "Nein",
    common_00245: "Alle Standorte",
    common_00246: "Passwörte ändern",
    common_00247: "Login mit alten Passwort",
    common_00248: "Login mit neuen Passwort",
    common_00249: "Buchstaben und Zahlen verwenden",
    common_00250: "Aktuelles Login-Passwort",
    common_00251: "Bitte altes Passwort eingeben",
    common_00252: "Bitte Passwort eingeben",
    common_00253: "Bitte Passwort erneut eingeben",
    common_00254: "Passwörter stimmen nicht überein",
    common_00255: "suchen",
    common_00256: "m",
    common_00257: "w",
    common_00258: "Profilbild",
    common_00259: "Nutzernahme",
    common_00260: "Geschlecht",
    common_00261: "钱包余额",
    common_00262: "Nutzerdetails",
    common_00263: "Ladevorgänge anzeigen",
    common_00264: "Keine Öffentlichkeit",
    common_00265: "Hinweis",
    common_00266: "Download abgebrochen",
    common_00267: "Download gestartet",
    common_00268: "Erneut eingeben",
    common_00269: "用户车辆认证",
    common_00270: "Schwarze",
    common_00271: "reset",
    common_00272: "Abschließen",
    common_00273: "Ja",
    common_00274: "Nein",
    common_00275: "Parameter sind leer",
    common_00276: "Bitte geben Sie eine positive Ganzzahl unter 100 ein",
    common_00277: "Betreibertarif",
    common_00278: "Aufladen",
    common_00279: "Einheit",
    common_00280: "erforderlich",
    common_00281: "Einstellung erfolgreich",
    common_00282: "Operation",
    common_00283: "Marke auswählen",
    common_00284: "Modell auswählen",
    common_00285: "Manuelle Eingabe",
    common_00286: "Fahrzeugmarke | Modell",
    common_00287: "Bitte vorherigen Schritt speichern",
    common_00288: "Aktion abbrechen",
    common_00289: "AC",
    common_00290: "DC",
    common_00291: "Gateway",
    common_00292: "deaktiviert",
    common_00293: "Aktiviert",
    common_00294: "einstellen",
    common_00295: "Ergebnis übertragen",
    common_00296: "Änderung wurde auf {allDevice} Geräte übertragen, {sucDevice} waren erfolgreich, {faiDevice} sind fehlgeschlagen",
    common_00297: "Gerätenummer",
    common_00298: "Gerätename",
    common_00299: "Erfolg",
    common_00300: "Fehler",
    common_00301: "Warten auf Antwort",
    common_00302: "off-line",
    common_00303: "Schließen",
    common_00304: "aktuelle Ladestation",
    common_00305: "Änderung übernehmen",
    common_00306: "Werbungmanagement",
    common_00307: "Wartung der Ausrüstung",
    common_00308: "Funktionen von Dritten",
    common_00309: "Entfernen",
    common_00310: "Wahl",
    common_00311: "zurück",
    common_00312: "Startdatum",
    common_00313: "Enddatum",
    common_00314: "Ladestation auswählen",
    common_00315: "Partner auswählen",
    common_00316: "Gerätstypen auswählen",
    common_00317: "Gruppe auswählen",
    common_00318: "OEM Plattform",
    common_00319: "Start",
    common_00320: "Betreiberplattform",
    common_00321: "vergrößern",
    common_00322: "schmal",
    common_00323: "Daten exportieren",
    common_00324: "Karte der Station",
    common_00325: "Fzg-MAC",
    common_00326: "Optional",
    common_00327: "Bitte auswählen",
    common_00360: "Basisinformationen",
    common_00361: "Ladestation mit Angebote",
    common_00362: "Gruppemitgliedermanagement",
    common_00363: "Ladevorgänge",
    common_00364: "Ladestatistik",
    common_00365: "Edit",
    common_10000: 'Typ of aktivität',
    common_10001: 'Anzahl der tätigkeiten',
    common_10002: 'Starte eine party',
    common_10003: '维保首页',
    common_10004: '维保中心',
    common_10005: '场站维保分析',
    common_10006: "Wave ist das titelblatt",
    common_10007: "kundenspezifisch",
    common_10008: "Titelseite vom schatzblatt",
    common_20009: "活动总览",
    common_10009: "Sind sie sicher, dass sie auf die alte v-geschwindigkeit zugreifen können?<br/>Ab dem 28. Februar 2022 ist der besitzer - typ v-2 nicht mehr auf kurs. Wissen sie nun bescheid!",
    common_20008: "Bitte geben Sie den Namen der Website ein",
    //能源中心
    common_20010: 'Befehl ausführen',
    common_20011: 'Ein gewinn Bewachung',
    common_20012: 'Ein bolzen management',
    common_20013: 'Die energiestatistiken',
    common_20014: 'Speicher',
    common_20015: 'Statistik',
    common_20016: 'Zentrum für energie',
    common_20017: 'Max-Power mode',
    common_20018: 'Ökoökonomisches mode',
    common_20019: 'Auto mode',
    
    common_10010: "v2 entry",
    // 工单
    common_31000: "工单系统",
    common_31001: "工单管理",
    common_31002: "工单分类",
    common_31003: "工单统计",
    common_31004: "知识库",
    common_31005: "请先绑定公众号",
    common_31006: "发起工单",
    common_40000: '设备寿命保养',
    common_41000: '请填写正确',
}
